import { render, staticRenderFns } from "./qs2-03.vue?vue&type=template&id=5f09d81e&scoped=true&"
import script from "./qs2-03.vue?vue&type=script&lang=js&"
export * from "./qs2-03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f09d81e",
  null
  
)

export default component.exports